///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import messages from "../helpers/messages";
import Analytics from "../components/Bid/analytics/Analytics";
import AnalyticsGridSection from "../components/Bid/analytics/AnalyticsGridSection";
import { reset } from "../slices/analyticsSlice";
import { resetBidSummary } from "../slices/bidSummarySlice";

export const PricingAnalytics = () => {
  const {
    user: { division }
  } = useSelector(state => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetBidSummary());
    dispatch(reset());
  }, [dispatch]);

  return (
    <div className="bid pricing">
      <h1 data-testid="pricing-analytics" className="alpha-heading pt-16 px-16">
        {messages.analytics.defaultMessage}
      </h1>
      <Analytics userDivision={division} onMount={() => {}} />
      <AnalyticsGridSection division={division} />
    </div>
  );
};

export default PricingAnalytics;
